import React, { ChangeEvent } from "react";
import Input from "../Inputs";
import Modal from "../Modal";
import { CONSTANTS } from "../../constants/Constants";
import Select from "../Select";
import moment from "moment";
import logoPlaceHolder from "../../assets/images/logo_placeholder.png"

interface EduModalProps {
  payload: any;
  country?: string;
  city?: string;
  countryOptions: {}[];
  cityOptions: {}[];
  changeLocationHandler: (
    e: ChangeEvent<HTMLSelectElement>,
    state?: "education"
  ) => void;
  eduChangeHandler: (e: ChangeEvent, journey: string) => void;
  saveEduHandler: () => void;
  setIsModalOpen: any;
  cityError: string;
}

const EduModal: React.FC<EduModalProps> = ({
  payload,
  countryOptions,
  cityOptions,
  changeLocationHandler,
  eduChangeHandler,
  saveEduHandler,
  setIsModalOpen,
  cityError,
}) => {
  return (
    <Modal
      modal_handler={setIsModalOpen}
      save_handler={saveEduHandler}
      other_classes="w-5/12"
      modal_title={CONSTANTS.MODIFY_EDUCATION_TXT}
    >
      <div>
        <div className="m-auto flex justify-evenly space-x-5">
          <div className="columns-1 mb-4">
            <label
              htmlFor="update_profile_image"
              className="cursor-pointer text-center flex flex-col items-center justify-center text-sm"
            >
              <img
                src={
                  payload?.[
                    CONSTANTS.PAYLOAD_KEYS.CREATE_UPDATE_RESOURCE_KEYS.IMAGE_URL
                  ] || logoPlaceHolder
                }
                alt="Company Logo"
                className="object-contain w-24 h-24 rounded-full border border-gray-300"
              />
              {CONSTANTS.LOGO_TXT}
            </label>
            <input
              onChange={(e: ChangeEvent)=>eduChangeHandler(e, CONSTANTS.EDUCATION_HEADING_TXT)}
              name={
                CONSTANTS.PAYLOAD_KEYS.CREATE_UPDATE_RESOURCE_KEYS.IMAGE_FILE
              }
              id="update_profile_image"
              className="hidden"
              type="file"
            />
          </div>
          <div className="w-96 space-y-4">
            <div>
              <label className="block text-sm font-medium text-gray-700">
                {CONSTANTS.INSTITUTE_TXT}
                <span className="text-error mr-1">*</span>
              </label>
              <Input
                input_name={
                  CONSTANTS.PAYLOAD_KEYS.CREATE_UPDATE_RESOURCE_KEYS.INSTITUTE
                }
                value={
                  payload?.[
                    CONSTANTS.PAYLOAD_KEYS.CREATE_UPDATE_RESOURCE_KEYS.INSTITUTE
                  ]
                }
                change_handler={(e: ChangeEvent)=>eduChangeHandler(e, CONSTANTS.EDUCATION_HEADING_TXT)}
                placeholder="Your Institute"
                other_classes="text-xs h-[30px]"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700">
                {CONSTANTS.DEGREE_TXT}
                <span className="text-error mr-1">*</span>
              </label>
              <Input
                input_name={
                  CONSTANTS.PAYLOAD_KEYS.CREATE_UPDATE_RESOURCE_KEYS.DEGREE
                }
                value={
                  payload?.[
                    CONSTANTS.PAYLOAD_KEYS.CREATE_UPDATE_RESOURCE_KEYS.DEGREE
                  ]
                }
                change_handler={(e: ChangeEvent)=>eduChangeHandler(e, CONSTANTS.EDUCATION_HEADING_TXT)}
                placeholder="Your Degree"
                other_classes="text-xs h-[30px]"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700">
                {CONSTANTS.STARTED_ON_TXT}
              </label>
              <Input
                type="month"
                input_name={
                  CONSTANTS.PAYLOAD_KEYS.CREATE_UPDATE_RESOURCE_KEYS.STARTED_ON
                }
                value={
                  payload?.[
                    CONSTANTS.PAYLOAD_KEYS.CREATE_UPDATE_RESOURCE_KEYS
                      .STARTED_ON
                  ]
                    ? moment(
                        payload?.[
                          CONSTANTS.PAYLOAD_KEYS.CREATE_UPDATE_RESOURCE_KEYS
                            .STARTED_ON
                        ]
                      ).format("YYYY-MM")
                    : ""
                }
                change_handler={(e: ChangeEvent)=>eduChangeHandler(e, CONSTANTS.EDUCATION_HEADING_TXT)}
                other_classes="text-xs h-[30px]"
                max={moment().format("YYYY-MM")} // Today se pehle disable karne ke liye
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700">
                {CONSTANTS.ENDED_ON_TXT}
              </label>
              <Input
                type="month"
                input_name={
                  CONSTANTS.PAYLOAD_KEYS.CREATE_UPDATE_RESOURCE_KEYS.ENDED_ON
                }
                value={
                  payload?.[
                    CONSTANTS.PAYLOAD_KEYS.CREATE_UPDATE_RESOURCE_KEYS.ENDED_ON
                  ]
                    ? moment(
                        payload?.[
                          CONSTANTS.PAYLOAD_KEYS.CREATE_UPDATE_RESOURCE_KEYS
                            .ENDED_ON
                        ]
                      ).format("YYYY-MM")
                    : ""
                }
                change_handler={(e: ChangeEvent)=>eduChangeHandler(e, CONSTANTS.EDUCATION_HEADING_TXT)}
                other_classes="text-xs h-[30px]"
                min={
                  payload?.[
                    CONSTANTS.PAYLOAD_KEYS.CREATE_UPDATE_RESOURCE_KEYS
                      .STARTED_ON
                  ]
                    ? moment(
                        payload?.[
                          CONSTANTS.PAYLOAD_KEYS.CREATE_UPDATE_RESOURCE_KEYS
                            .STARTED_ON
                        ]
                      ).format("YYYY-MM")
                    : moment().format("YYYY-MM")
                } // Start date se pehle disable karne ke liye
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700">
                {CONSTANTS.COUNTRY_TXT}
              </label>
              <Select
                value={payload?.countryId}
                options={countryOptions}
                handle_change={(e: React.ChangeEvent<HTMLSelectElement>) =>
                  changeLocationHandler(e, "education")
                }
                name={CONSTANTS.COUNTRY_TXT}
                other_classes="text-xs h-[30px] rounded-md"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700">
                {CONSTANTS.CITY_TXT}
              </label>

              <Select
                value={payload?.cityId}
                options={cityOptions}
                handle_change={(e: React.ChangeEvent<HTMLSelectElement>) =>
                  changeLocationHandler(e, "education")
                }
                name={
                  CONSTANTS.PAYLOAD_KEYS.CREATE_UPDATE_RESOURCE_KEYS.LOCATION_ID
                }
                other_classes="text-xs h-[30px] rounded-md"
              />
              <small className="text-error">{cityError}</small>
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700">
                {CONSTANTS.SHOW_ON_PROFILE_TXT}
              </label>
              <Select
                name={CONSTANTS.PAYLOAD_KEYS.CREATE_UPDATE_RESOURCE_KEYS.STATUS}
                value={
                  payload?.[
                    CONSTANTS.PAYLOAD_KEYS.CREATE_UPDATE_RESOURCE_KEYS.STATUS
                  ]
                }
                handle_change={(e: ChangeEvent)=>eduChangeHandler(e, CONSTANTS.EDUCATION_HEADING_TXT)}
                options={[
                  {
                    id: CONSTANTS.ENABLED_TXT.toLocaleUpperCase(),
                    name: CONSTANTS.YES_TXT,
                  },
                  {
                    id: CONSTANTS.DISABLED_TXT.toLocaleUpperCase(),
                    name: CONSTANTS.NO_TXT,
                  },
                ]}
                other_classes="text-xs h-[30px] rounded-md"
              />
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default EduModal;
